import TipJar from "./TipJar";

export const ProfileJar = ({ jar }) => {
  if (!jar) return null;
  const isGoal = jar.mode === "goal";
  return (
    <div data-testid="profile-tip-jar" className="mt-4 bg-card border border-border rounded-2xl p-5 flex flex-col items-center text-center">
      <p className="font-mono text-xs uppercase tracking-widest text-copper">
        {isGoal ? "Working toward a goal" : "Community support"}
      </p>
      <TipJar balance={isGoal ? jar.raised : jar.total || 0} pct={jar.pct} className="w-24 h-auto my-3 drop-shadow-sm" />
      {isGoal ? (
        <>
          {jar.title && <p className="text-foreground/90 -mt-1 mb-2">{jar.title}</p>}
          <p className="text-sm font-semibold text-bronze" data-testid="profile-jar-goal">${jar.raised.toFixed(2)} / ${jar.goal.toFixed(2)}</p>
          <div className="w-full max-w-xs h-2.5 bg-secondary rounded-full mt-2 overflow-hidden">
            <div className="h-full theme-sage rounded-full transition-all" style={{ width: `${Math.min(100, jar.pct)}%` }} />
          </div>
          <p className="text-xs text-muted-foreground mt-1.5">
            {jar.raised >= jar.goal ? "Goal reached — thank you, everyone! 🎉" : `${Math.round(jar.pct)}% of the way there 💛`}
          </p>
        </>
      ) : jar.show_amount && jar.total != null ? (
        <p className="text-sm font-semibold text-bronze" data-testid="profile-jar-total">
          ${jar.total.toFixed(2)} <span className="font-normal text-muted-foreground">received all-time</span>
        </p>
      ) : (
        <p className="text-sm text-muted-foreground">Supported by the community 💛</p>
      )}
    </div>
  );
};

export default ProfileJar;
